/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { CardsControlles, IfreamControlles } from './Cards';

class App extends React.Component {
  constructor() {
    super();
    this.state = {
      ITEM: [],
      allItem: [],
      ifream_Click: false,
      ifream_URL: "",
      click: [false, false, false]
    }
    this.searchInputChange = this.searchInputChange.bind(this);
  }
  componentDidMount() {
    let allItem = [];
    let Item = [];
    for (let i = 0; i < window.Situation_Item.length; i++) {
      window.Situation_Item[i].ITEM.map(
        (item) => {
          allItem.push(item);
        }
      );
    }
    for (let i = 0; i < window.Reference_Layer_Item.length; i++) {
      window.Reference_Layer_Item[i].ITEM.map(
        (item) => allItem.push(item)
      );
    }
    for (let i = 0; i < window.Reference_features_Item.length; i++) {
      window.Reference_features_Item[i].ITEM.map(
        (item) => allItem.push(item)
      );
    }
    this.setState({ ITEM: Item, allItem: allItem });
  }
  ItemClick(item) {
    this.setState({ ITEM: item, ifream_Click: false });
  }
  DemoClick(URL) {
    var activity = window.Metro.activity.open({
      type: 'cycle',
      overlayColor: '#fff',
      overlayAlpha: 1,
      text: '<div class=\'mt-2 text-small\'>請稍候......</div>',
    });

    setTimeout(function () {
      window.Metro.activity.close(activity);
    }, 3000);

    this.setState({ ifream_Click: true, ifream_URL: URL });
  }
  searchInputChange(event) {
    let searchStr = event.target.value;
    let reg = new RegExp(searchStr, "gi");
    let allItem = [];
    let Item = [];
    this.state.allItem.map(
      (item) => allItem.push(item)
    );
    if (searchStr === "" || searchStr === null) {
      this.setState({ ITEM: Item });
    }
    else {
      let resArr = [];
      allItem.map(
        (Item) => {
          let count = 0;
          Item.TAG.filter(
            item => {
              if (reg.test(item)) {
                count++;
              }
            }
          )
          if (count > 0) {
            resArr.push(Item);
          }
        }
      );
      this.setState({ ITEM: resArr, ifream_Click: false });
    }
  }
  menuClick(id, token) {
    let element = window.$("#" + id);
    let click = this.state.click;
    if (click[token]) {
      element.hide();
      click[token] = false;
      this.setState({ click: click });
    }
    else {
      element.show();
      click[token] = true;
      this.setState({ click: click });
    }
  }
  closeDemo() {
    this.setState({ ifream_Click: false });
  }
  render() {
    let Situation_Item = window.Situation_Item;
    let Reference_Layer_Item = window.Reference_Layer_Item;
    let Reference_features_Item = window.Reference_features_Item;
    return (
      <div>
        <div data-role="navview" data-expand="fs" data-compact="false">
          <div className="navview-pane" style={{ position: "fixed" }}>
            <button className="pull-button">
              <span className="default-icon-menu" style={{ width: "25px", height: "25px" }}></span>
            </button>
            <div className="suggest-box">
              <input type="text" data-role="input" data-clear-button="false" data-search-button="true" onChange={this.searchInputChange}></input>
              <button className="holder">
                <span className="mif-search"></span>
              </button>
            </div>
            <ul className="navview-menu">
              {
                this.state.ifream_Click ?
                  <li>
                    <a style={{ cursor: "pointer", color: "red", fontWeight: "bold" }} className="closeItem" data-role="ripple" data-ripple-color="#1ba1e2" onClick={() => this.closeDemo()}>
                      <span className="icon"><span className="mif-cross-light"></span></span>
                      <span className="caption">關閉Demo</span>
                    </a>
                  </li>
                  : null
              }
              <li className="item-header">場景</li>
              <li>
                <a style={{ cursor: "pointer" }} className="dropdown-toggle" data-role="ripple" data-ripple-color="#1ba1e2" onClick={() => this.menuClick("situation", 0)}>
                  <span className="icon"><span className="mif-folder"></span></span>
                  <span className="caption">使用情境</span>
                </a>
                <ul className="navview-menu" id="situation" style={{ display: "none" }}>
                  {
                    Situation_Item.map(
                      (item) =>
                        <li>
                          <a onClick={() => this.ItemClick(item.ITEM)} style={{ cursor: "pointer" }} data-role="ripple" data-ripple-color="#1ba1e2">
                            <span className="caption">{item.TYPE}</span>
                          </a>
                        </li>
                    )
                  }
                </ul>
              </li>
              <li className="item-separator"></li>
              <li className="item-header">基本功能</li>
              <li>
                <a style={{ cursor: "pointer" }} className="dropdown-toggle" data-role="ripple" data-ripple-color="#1ba1e2" onClick={() => this.menuClick("layer", 1)}>
                  <span className="icon"><span className="mif-folder"></span></span>
                  <span className="caption">圖層</span>
                </a>
                <ul className="navview-menu" id="layer" style={{ display: "none" }}>
                  {
                    Reference_Layer_Item.map(
                      (item) =>
                        <li>
                          <a onClick={() => this.ItemClick(item.ITEM)} style={{ cursor: "pointer" }} data-role="ripple" data-ripple-color="#1ba1e2">
                            <span className="caption">{item.TYPE}</span>
                          </a>
                        </li>
                    )
                  }
                </ul>
              </li>
              <li>
                <a style={{ cursor: "pointer" }} className="dropdown-toggle" data-role="ripple" data-ripple-color="#1ba1e2" onClick={() => this.menuClick("features", 2)}>
                  <span className="icon"><span className="mif-folder"></span></span>
                  <span className="caption">功能</span>
                </a>
                <ul className="navview-menu" id="features" style={{ display: "none" }}>
                  {
                    Reference_features_Item.map(
                      (item) =>
                        <li>
                          <a onClick={() => this.ItemClick(item.ITEM)} style={{ cursor: "pointer" }} data-role="ripple" data-ripple-color="#1ba1e2">
                            <span className="caption">{item.TYPE}</span>
                          </a>
                        </li>
                    )
                  }
                </ul>
              </li>
            </ul>
          </div>
          <div className="navview-content">
            <div style={{ position: "unset" }} data-role="appbar" data-expand-point="md">
              <div className="ml-auto d-flex-md">
                {
                  false ? (<ul className="app-bar-menu" data-role="ripple">
                    <li><a href="https://www.pilotgaea.com.tw" target="_blank">官方網站</a></li>
                    <li><a href="https://nlscsample.pilotgaea.com.tw/demo/ProgrammingGuide/" target="_blank">文件</a></li>
                    <li><a href="https://nlscsample.pilotgaea.com.tw/demo/Reference" target="_blank">Reference</a></li>
                    <li><a href="https://demo.pilotgaea.com.tw/" target="_blank">Demo</a></li>
                  </ul>) : null
                }

              </div>
            </div>
            {
              this.state.ITEM.length === 0 ? <img src="Demo首頁.png" style={{ width: "100%", height: "100%" }}></img> :
                this.state.ifream_Click ? <IfreamControlles ifream_URL={this.state.ifream_URL} /> : <CardsControlles Item={this.state.ITEM} DemoClick={(URL) => this.DemoClick(URL)} />
            }
          </div>
        </div>
      </div>
    );
  }
}
export default App;
